import {useContext} from 'react';
import {KEIConnectContext} from '../providers';

export const useKEIConnect = () => {
  const connect = useContext(KEIConnectContext);

  if (!connect) {
    throw new Error(
      'Missing the KEIConnect provider. Please make sure you have added it before using useKEIConnect'
    );
  }

  return connect;
};
